/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Delete_TitleInputs */

const es_feedback_delete_title = /** @type {(inputs: Feedback_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar Feedback`)
};

const en_feedback_delete_title = /** @type {(inputs: Feedback_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Feedback`)
};

/**
* | output |
* | --- |
* | "Delete Feedback" |
*
* @param {Feedback_Delete_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_delete_title = /** @type {((inputs?: Feedback_Delete_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Delete_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_delete_title(inputs)
	return en_feedback_delete_title(inputs)
});
export { feedback_delete_title as "feedback.delete.title" }